<template>
  <div id="app">
    <Header v-if="router.indexOf('/user') !== 0" />
    <!-- <transition name="fade"> -->
      <router-view/>
    <!-- </transition> -->
  </div>
</template>

<style lang="scss">
@import '@/scss/base.scss';
* {
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
}

html, body {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  font-size: 1rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  width: 100%;
  min-height: 100%;
  display: -webkit-box;
  box-orient: vertical;
  -webkit-box-orient: vertical;
}

.container {
  max-width: 1200px;
  margin: auto;
}

.el-page-header {
  margin-top: 20px;
  margin-bottom: 28px;
}

.user-container {
  position: absolute;
  left:280px;
  width: calc(100% - 320px);
  height: calc(100% - 40px);
  overflow-y: auto;
  padding: 20px;
}

</style>
<script>
import Header from '@/components/Header.vue'

export default {
  name: 'App',
  data() {
    return {
      showHeader: true,
    }
  },
  components: {
    Header,
  },
  mounted() {
  },
  computed: {
    router() {
      return this.$store.state.router;
    },
  },
}
</script>
